import { useLocation } from 'react-router-dom';
import useAuth from './useAuth';
import type { PlatformFeatureKey } from 'src/types/platformFeatures';

export function useActiveTenantFeatures(): string[] {
  const { user } = useAuth();
  const { pathname } = useLocation();

  return user?.getActiveTenant?.(pathname)?.features ?? [];
}

export function useTenantFeature(featureKey: PlatformFeatureKey): boolean {
  const features = useActiveTenantFeatures();
  return features.includes(featureKey);
}
